import { createStore, compose, combineReducers } from "redux";
import { 
    cartReducer, 
    searchingReducer, 
    menuReducer, 
    productPageReducer, 
    popupsReducer, 
    addProductReducer,
    changeProductReducer,
    orderFormReducer,
} from "./reducers/reducers";

import { firebaseReducer } from 'react-redux-firebase'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/analytics'

const config = {
    apiKey: "AIzaSyB87XKLbGCb01BCd1x9RFFBv-nDB90CNCA",
    authDomain: "flagman-aeda7.firebaseapp.com",
    databaseURL: "https://flagman-aeda7.firebaseio.com",
    projectId: "flagman-aeda7",
    storageBucket: "flagman-aeda7.appspot.com",
    messagingSenderId: "703313665525",
    appId: "1:703313665525:web:f7360c2fc45cb7988794bc",
    measurementId: "G-40W2585J4D"
};

// !! DEVELOPER PROFILE !!
// let config = {
//     apiKey: "AIzaSyAtVBOFIV1vG-KND6AtXwcNhgouL3ODOpE",
//     authDomain: "flagman-19699.firebaseapp.com",
//     databaseURL: "https://flagman-19699.firebaseio.com",
//     projectId: "flagman-19699",
//     storageBucket: "flagman-19699.appspot.com",
//     messagingSenderId: "99128525358",
//     appId: "1:99128525358:web:0304ab88ed272e85e555bf"
// };

const rootReducer = combineReducers({
    firebase: firebaseReducer,
    cart: cartReducer,
    menu: menuReducer,
    searching: searchingReducer,
    product_page: productPageReducer,
    popups: popupsReducer,
    add_product: addProductReducer,
    change_product: changeProductReducer,
    order_form_data: orderFormReducer
})

export const store = createStore(
    rootReducer,
    compose(
        window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    )
);

const rrfConfig = {
    userProfile: 'users',
    useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
}

export const rrfProps = {
    firebase,
    config: rrfConfig,
    dispatch: store.dispatch,
}

export const fireservice = firebase.initializeApp(config);
firebase.analytics();
export const fire_storage = firebase.storage();
